import { render, staticRenderFns } from "./GeneralOrderList.vue?vue&type=template&id=022369ca&scoped=true&"
import script from "./GeneralOrderList.vue?vue&type=script&lang=js&"
export * from "./GeneralOrderList.vue?vue&type=script&lang=js&"
import style0 from "./GeneralOrderList.vue?vue&type=style&index=0&id=022369ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022369ca",
  null
  
)

export default component.exports